import { render, staticRenderFns } from "./ViewVtp.vue?vue&type=template&id=3e1e9006&"
import script from "./ViewVtp.vue?vue&type=script&lang=js&"
export * from "./ViewVtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports